import { render, staticRenderFns } from "./SidebarCartAdditionalProducts.vue?vue&type=template&id=47f9626c&"
import script from "./SidebarCartAdditionalProducts.vue?vue&type=script&lang=js&"
export * from "./SidebarCartAdditionalProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f9626c')) {
      api.createRecord('47f9626c', component.options)
    } else {
      api.reload('47f9626c', component.options)
    }
    module.hot.accept("./SidebarCartAdditionalProducts.vue?vue&type=template&id=47f9626c&", function () {
      api.rerender('47f9626c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/SidebarCartAdditionalProducts.vue"
export default component.exports